import React from 'react';
import PropTypes from 'prop-types';
import S from './Breadcrumbs.styles';

const Breadcrumbs = ({ links }) => (
  <S.Breadcrumbs>
    {links.map(l => (
      <S.Breadcrumb key={l.id} to={l.link}>
        {l.text}
      </S.Breadcrumb>
    ))}
  </S.Breadcrumbs>
);

Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default React.memo(Breadcrumbs);
